import gql from 'graphql-tag'
import {internalStatus} from "../../Constants/Constant"

let cities = JSON.parse(localStorage.getItem('cities'));
let truckOrderCities = cities.map(curnt => curnt.city);
truckOrderCities = truckOrderCities.length?JSON.stringify(truckOrderCities):null;    //stringify array since query is a string

export const SUBSCRIBE_TRUCK_ORDERS = gql`
subscription truckOrders($startDate:date!, $endDate:date!){
 truckOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}}]}) {
    id
    truckOrderNumber
    date
    transporterId
    Transporter{id name}
    driverId
    driverDetail{id name}
    truckId
    truck{id name platNo}
    fromCity
    toCity
    pickCity{id shortCode}
    dropCity{id shortCode}
    commitedWeight
    price
    bookingDate
    lrCommision
    ewayBillNo
    status
    orderDetailsArr{
    id
    lrObject
    ewayBillNo
    isEwayBillVerified
    order{
        id
        orderNumber
        clientobject
        pickuppartyobject
        droppingpartyobject
        materials
        note
          }
      }
    }
  }
 `
export const SUBSCRIBE_TRUCK_ORDER_BY_ID = gql`
 subscription truckOrderDetail($truckOrderId: uuid!){
  truckOrderDetail:truckOrders(where: {id: {_eq: $truckOrderId}}) {
    id
    bookingDate
    truckOrderNumber
    InternalStatus{id name}
    Transporter{id name}
    driverDetail{id name mobile}
    truck{id name platNo}
    fromCity
    toCity
    commitedWeight
    price
    lrCommision
    ewayBillNo
    status
    }
 }
`


// truckOrders(where: {_and: {date: {_eq: $filterDate}, fromCity: {_eq: $filterCity}}}) {
export const SUBSCRIBE_TRUCK_ORDERS_BY_STATUS = gql`
 subscription truckOrders{
  truckOrders(where: {_and: [{status: {_neq: "Completed"}},{internalstatus: {_eq: ${internalStatus.waitingForDeparture}}}]}) {
    id
    truckOrderNumber
    truck{id name platNo company{id name} }
    driverDetail{id name}
    orderDetailsArr{
      id
      order{
        id
        orderNumber
        pickuppartyobject
        droppingpartyobject
          }
       }
    }
 }
`
export const SUBSCRIBE_OCCUPIED_TRUCKS_AND_DRIVERS = gql`
subscription truckOrders($todayDate: date!){
 occupiedTruckAndDriverIds: truckOrders(where: {date: {_eq: $todayDate}}) {
    id
    truckId
    driverId
    }
  }
 `
export const SUBSCRIBE_LAST_TRUCK_ORDER_NUMBER = gql`
subscription truckOrders($todayDate: date!){
 lastTruckOrder: truckOrders(where: {date: {_eq: $todayDate}}, order_by: {createdAt: desc}, limit: 1) {
      id
      truckOrderNumber
  }
  }
 `
export const SUBSCRIBE_EXCEL_OUTGOING_TRUCK_ORDERS = gql`
 subscription outgoing_truckOrders($startDate:date!, $endDate:date!){
  outgoing_truckOrders: truckOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}},{ status: {_eq: "InProgress"}},
                        {_or: [{fromCity: {_in: ${truckOrderCities}}}]},
                        { internalstatus: {_in: [${internalStatus.waitingForDeparture}]}}]}) {
    id
    date
    bookingDate
    truckOrderNumber
    InternalStatus{id name}
    Transporter{id name}
    driverDetail{id name}
    truck{id name platNo}
    orderDetailsArr{id order{id materials}}
    fromCity
    toCity
    pickCity{id shortCode}
    dropCity{id shortCode}
    commitedWeight
    price
    lrCommision
    ewayBillNo
    status
    }
 }
`
export const SUBSCRIBE_EXCEL_ONCOMING_TRUCK_ORDERS = gql`
 subscription oncoming_truckOrders($startDate:date!, $endDate:date!){
  oncoming_truckOrders: truckOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}},{ status: {_eq: "InProgress"}},
                        {_or: [{toCity: {_in: ${truckOrderCities}}}]},
                        { internalstatus: {_in: [${internalStatus.onTheWayToDropCityWarehouse},${internalStatus.atDestinationCityWarehouse}]}}]}) {
    id
    date
    bookingDate
    truckOrderNumber
    InternalStatus{id name}
    Transporter{id name}
    driverDetail{id name}
    truck{id name platNo}
    orderDetailsArr{id order{id materials}}
    fromCity
    toCity
    pickCity{id shortCode}
    dropCity{id shortCode}
    commitedWeight
    price
    lrCommision
    ewayBillNo
    status
    }
 }
`
export const SUBSCRIBE_EXCEL_OPEN_TRUCK_ORDERS = gql`
 subscription open_truckOrders($startDate:date!, $endDate:date!){
  open_truckOrders: truckOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}},
                         {_or: [{fromCity: {_in: ${truckOrderCities}}}, {toCity: {_in: ${truckOrderCities}}}]},
                         { status: {_neq: "Completed"}}, { status: {_neq: "Cancel"}}]}) {
    id
    date
    bookingDate
    truckOrderNumber
    InternalStatus{id name}
    Transporter{id name}
    driverDetail{id name}
    truck{id name platNo}
    orderDetailsArr{id order{id materials}}
    fromCity
    toCity
    pickCity{id shortCode}
    dropCity{id shortCode}
    commitedWeight
    price
    lrCommision
    ewayBillNo
    status
    }
 }
`
export const SUBSCRIBE_EXCEL_COMPLETED_TRUCK_ORDERS = gql`
 subscription completed_truckOrders($startDate:date!, $endDate:date!){
  completed_truckOrders: truckOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}},
                         {_or: [{fromCity: {_in: ${truckOrderCities}}}, {toCity: {_in: ${truckOrderCities}}}]},
                         { status: {_eq: "Completed"}}]}) {
    id
    date
    bookingDate
    truckOrderNumber
    InternalStatus{id name}
    Transporter{id name}
    driverDetail{id name}
    truck{id name platNo}
    orderDetailsArr{id order{id materials}}
    fromCity
    toCity
    pickCity{id shortCode}
    dropCity{id shortCode}
    commitedWeight
    price
    lrCommision
    ewayBillNo
    status
    }
 }
`
export const SUBSCRIBE_EXCEL_CANCEL_TRUCK_ORDERS = gql`
 subscription cancel_truckOrders($startDate:date!, $endDate:date!){
  cancel_truckOrders: truckOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}},
                         {_or: [{fromCity: {_in: ${truckOrderCities}}}, {toCity: {_in: ${truckOrderCities}}}]},
                         { status: {_eq: "Cancel"}}]}) {
    id
    date
    bookingDate
    truckOrderNumber
    InternalStatus{id name}
    Transporter{id name}
    driverDetail{id name}
    truck{id name platNo}
    orderDetailsArr{id order{id materials}}
    fromCity
    toCity
    pickCity{id shortCode}
    dropCity{id shortCode}
    commitedWeight
    price
    lrCommision
    ewayBillNo
    status
    }
 }
`
export const SUBSCRIBE_TRUCK_ORDERS_BY_TRANSPORTER_ID = gql`
 subscription truckOrdersByTransporterId($startDate:date!, $endDate:date!, $transporterId:uuid!){
  truckOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}},{ transporterId: {_eq: $transporterId}}]}, order_by: {date: desc}) {
    id
    date
    bookingDate
    truckOrderNumber
    InternalStatus{id name}
    Transporter{id name}
    driverDetail{id name}
    truck{id name platNo}
    orderDetailsArr{id order{id materials}}
    fromCity
    toCity
    commitedWeight
    price
    lrCommision
    ewayBillNo
    status
    }
 }
`
export const SUBSCRIBE_ORDERS_BY_TRUCK_ORDER_ID = gql`
 subscription orders_by_truckOrderId($truckOrderId: uuid!){
  orders(where: {orderDetails: {transportVehicleAssignId: {_eq: $truckOrderId}}}, order_by: {createdAt: desc}) {
      id
      clientobject
      pickuppartyobject
      droppingpartyobject
      orderNumber
      pickupDate
      createdAt
      updated_at
      materials
      priority
      note
      notes(order_by: {createdOn: desc}, limit: 1){id note}
      internalstatus
      internalStatus{id name viewPath}
      orderDetails {
        id
        lrObject
        pickupConfirmation
        orderReadiness
        dispactchVerification
        pickupVehicleAssignId
        transportVehicleAssignId
        loadedInTruck
        ewayBillNo
        isEwayBillVerified
        pickupPoint
        dropPoint
      }
    }
 }
`
